import {zhouyitw, zhouyicn} from "./zhouyi.js"
import Sha256 from "./sha256.js";
import AesCtr from "./aes-ctr.js"
import { daYanArray, changingMap } from "./allNumbers.js";
export const btn_style_indigo_l1 = "btn waves-effect indigo lighten-1 waves-light btn-single"
export const btn_style_green_l3 = "btn waves-effect green lighten-3 waves-light btn-single"
export const btn_style_green_d3 = "btn waves-effect green darken-3 waves-light btn-single"
export const btn_style_green_l2 = "btn waves-effect green lighten-2 waves-light btn-single"
export const btn_style_green_d2 = "btn waves-effect green darken-1 waves-light btn-single"
export const btn_style_lime_d2 = "btn waves-effect lime darken-2 waves-light btn-single"
export const btn_style_lime_d3 = "btn waves-effect lime darken-3 waves-light btn-single"
export const btn_style_blue_d2 = "btn waves-effect blue darken-2 waves-light btn-single"
export const btn_style_blue_d3 = "btn waves-effect blue darken-3 waves-light btn-single"
export const btn_style_light_blue_a3 = "btn waves-effect light-blue accent-3 waves-light btn-single"
export const btn_style_red_l3 = "btn waves-effect red lighten-1 waves-light btn-single"
export const btn_style_red_d2 = "btn waves-effect red darken-2 waves-light btn-single"
export const btn_style_purple_d2 = "btn waves-effect purple darken-2 waves-light btn-single"
export const btn_style_deep_purple_a1 = "btn waves-effect deep-purple accent-1 waves-light btn-single"
export const btn_style_cyan_d2 = "btn waves-effect cyan darken-2 waves-light btn-single"
export const btn_style_bluegrey_l2 = "btn waves-effect blue-grey lighten-2 waves-light btn-single"
export const btn_style_yellow_d2 = "btn waves-effect yellow darken-2 waves-light btn-single"
export const btn_style_yellow_d3 = "btn waves-effect yellow darken-3 waves-light btn-single"
export const btn_style_orange_d2 = "btn waves-effect orange darken-2 waves-light btn-single"
export const btn_style_teal = "btn waves-effect teal waves-light btn-single"

// You DO NOT want to change xiyiSalt
export const xiyiSalt =  "【九五】：觀我生，君子无咎。"
export const categories = [
  "健康", "事業", "感情", "時事", "出行", "是非", "其他",
]

// Decrypt encrypted text
export function decryptText(encryptedText) {
    return AesCtr.decrypt(encryptedText, xiyiSalt, 256)
}

// function getMailtoUrl(to, subject, body) {
export  function getMailtoUrl() {
    var args = []
    let to = "ixiyi88@xiyi.io"
    let subject = "我要加入成為學生會員"
    let body =
      "帳號（註冊時用的email）： \n姓名： \n學校： \n科系： \n年級： \n為什麼想學易： \n您的情況： \n"

    if (typeof subject !== "undefined") {
      args.push("subject=" + encodeURIComponent(subject))
    }
    if (typeof body !== "undefined") {
      args.push("body=" + encodeURIComponent(body))
    }

    var url = "mailto:" + encodeURIComponent(to)
    if (args.length > 0) {
      url += "?" + args.join("&")
    }
    return url
  }

export function backToTop() {
  // Auto scroll back to the top of the page
  requestAnimationFrame(() => window.scrollTo(0, 0))
}

export function scrollToId(id) {
  let el = document.getElementById(id);
  el.scrollIntoView();
}

export function formatDate(date) {
  var d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear()

  if (month.length < 2) month = "0" + month
  if (day.length < 2) day = "0" + day

  return [year, month, day].join("-")
}

export function buildComment(dt, comment) {
  if (comment.length > 0) {
    return "<strong>日期： </strong>" + dt + "<br/><strong>新增筆記：</strong><br/>" + comment
  } else {
    return ""
  }
}

export function guaCommentsToString(commentArray) {
  let htmlCommentString = ""
  let contentString = ""
  for (var i = 0; i < commentArray.length; i++) {
    contentString = AesCtr.decrypt(commentArray[i].content, xiyiSalt, 256)
    htmlCommentString = buildComment(commentArray[i].dt, contentString) + 
      "<hr/>"  +  
      htmlCommentString
  }
  
  // console.log("@ helper.guaCommentsToString: incoming commentArray is ", commentArray)
  // console.log("@ helper.guaCommentsToString: returning htmlCommentString is ", htmlCommentString)
  return htmlCommentString
}

// ========= Below Gua Detail functions ===============
export function buildYaoColorArray(numStr) {
  let yaoColor = []
  let movingYaoArray = getMovingYaoPositions(numStr).split(",")
  let changingYao = checkChanging(numStr)

  for (var i = 6; i >= 1; i--) {
    if (changingYao == i) {
//      if (checkChangingMatch(numStr) == "無宜變") {
        if (checkChangingMatch(numStr) == "unchanged") {
          yaoColor.push("static")
      } else {
        yaoColor.push("change")
      }
    } else if (movingYaoArray.includes(i.toString())) {
      yaoColor.push("unstable")
    } else {
      yaoColor.push("static")
    }
  }

  return yaoColor
}



export function getGuaText(codeStr, lang) {
  //console.log("@ helper getYaoText code = " + codeStr)
  if (lang == "TW") {
    return zhouyitw[codeStr]
  } else {
    return zhouyicn[codeStr]
  }
  
}
// ========= Below Gua result function group ==========

export function reverseString(str) {
  return str.split("").reverse().join("");
}

// Check changing yao
// Input: numStr
export function checkChanging(ns) {
    let bigNum = 55
    let total = 0
    let diff = 0
    let changingYao = 0

    if (ns.length == 6) {
      for (let i = 0; i < ns.length; i++) {
        total = total + parseInt(ns[i])
      }

      diff = bigNum - total 

      //console.log("@helpers.checkChanging diff = " + diff)

      if ([1, 12, 13].includes(diff)) changingYao = "1"
      else if ([2, 11, 14].includes(diff)) changingYao = "2"
      else if ([3, 10, 15].includes(diff)) changingYao = "3"
      else if ([4, 9, 16].includes(diff)) changingYao = "4"
      else if ([5, 8, 17].includes(diff)) changingYao = "5"
      else if ([6, 7, 18, 19].includes(diff)) changingYao = "6"
      //console.log("@helpers.checkChanging changingYao = " + changingYao)

      return changingYao
      //alert(changingYao);
      // if (changingYao <= 6) return changingYao.toString()
      // else if (changingYao > 6 && changingYao <= 12)
      //   return (13 - changingYao).toString()
      // else if (changingYao > 12 && changingYao <= 18)
      //   return (changingYao - 12).toString()
      // else return "6"
    } else {
      return ""
    }
  }

export function getMovingYaoPositions(ns) {
    // change 6 to 7; change 9 to 8
    let myao = [] // reset movingYao array
    for (let i = 0; i < ns.length; i++) {
      if (ns[i] == 6) {
        myao.push(i + 1)
      } else if (ns[i] == 9) {
        myao.push(i + 1)
      }
    }
    //alert(cs);
    //console.log("@ helpers: getMovingYaoPositions", myao.toString());
    if (myao.length == 0) return "unmoved"
    // if (myao.length == 0) return "無動爻"
    else return myao.toString()
  }

  export function checkChangingMatch(ns) {
    var changingYao = checkChanging(ns)
    var movingYaoArray = getMovingYaoPositions(ns).split(",")

    //alert(movingYaoArray.toString() + " : " + changingYao);
    if (movingYaoArray.includes(changingYao)) {
      //console.log("@ helpers: checkChangingMatch - got changing yao = ", changingYao)
      return changingYao 
    }
    // if (movingYaoArray.includes(changingYao)) return changingYao + " 爻值宜變"
    else return "unchanged"
    //else return "無宜變"
  }

// This is to generate the moving gua (2nd zhi gua)
// if there is no change yao, this is also the 1st zhi gua
export function checkMoving(ns) {
// change 6 to 7; change 9 to 8
let cs = ""
//movingYao = []; // reset movingYao array
for (let i = 0; i < ns.length; i++) {
    if (ns[i] == 6) {
    cs = cs + "7"
    // movingYao.push(i);
    } else if (ns[i] == 9) {
    cs = cs = cs + "8"
    //movingYao.push(i);
    } else cs = cs + ns[i]
}
//alert(cs);
//alert(movingYao.toString());
return number2code(cs)
}

// generate zhi1 if there is one or use zhi2 as zhi1
export function generateZhi1Code(ns) {
  let cy = checkChanging(ns)
  let cs = ""
  let movingYao = ""
  let changingYaoPosition = 0
  //let movingYaoArray = getMovingYaoPositions(ns).split(",")
  movingYao = getMovingYaoPositions(ns).split(",")
  //alert("movig yao is " + movingYao.toString());
  //alert("cy is " + cy);

  if (movingYao.includes(cy)) {
    // flip the cy (changing Yao)
    for (let i = 0; i < ns.length; i++) {
      if (i == cy - 1) {
        if (ns[i] == 6) cs = cs + "7"
        else cs = cs + "8"
      } else {
        cs = cs + ns[i]
      }
    }
    //alert("cs is" + cs.toString());
    //console.log("@ helpers.generateZhi1Code returning number2code(cs) = " + number2code(cs))
    return number2code(cs)
  } else {
    changingYaoPosition = checkChangingMatch(ns)
    for (let i = 0; i < ns.length; i++) {
      if (i == changingYaoPosition) {
        if (ns[i] == 6) cs = cs + "7"
        else if (ns[i] == 9) cs = cs + "8"
        else alert("Something goes wrong! ns and i = " + ns + ", " + i)
      } else {
        cs = cs + ns[i]
      }
    }
    //console.log("@ helpers.generateZhi1Code, changingYao NOT in moving yaos. Returning = " + checkMoving(ns))
    return checkMoving(ns)
  }
  //return number2code(cs)
}

export function generateZhi1(ns) {
    let cy = checkChanging(ns)
    let cs = ""
    let movingYao = ""

    movingYao = getMovingYaoPositions(ns)
    //alert("movig yao is " + movingYao.toString());
    //alert("cy is " + cy);

    if (movingYao.includes(cy)) {
      // flip the cy (changing Yao)
      for (let i = 0; i < ns.length; i++) {
        if (i == cy - 1) {
          if (ns[i] == 6) cs = cs + "7"
          else cs = cs + "8"
        } else {
          cs = cs + ns[i]
        }
      }
      //alert("cs is" + cs.toString());
      return findGua(number2code(cs))
    } else {
      return findGua(checkMoving(ns))
    }
  }

export function zongGua(code) {
    return code.split("").reverse().join("")
  }

export function cuoGua(code) {
    let cuo = ""
    for (let i = 0; i < code.length; i++) {
      if (code[i] == 0) cuo += "1"
      else cuo += "0"
    }
    return cuo
  }

export function jiaoGua(code) {
    if (code.length == 6) {
      return code[3] + code[4] + code[5] + code[0] + code[1] + code[2]
    } else {
      return ""
    }
  }

export function huGua(code) {
    if (code.length == 6) {
      return code[1] + code[2] + code[3] + code[2] + code[3] + code[4]
    } else {
      return ""
    }
  }

export function gig14(code) {
    if (code.length == 6) {
      return code[0] + code[1] + code[2] + code[1] + code[2] + code[3]
    } else {
      return ""
    }
  }

export function gig15(code) {
    if (code.length == 6) {
      return code[0] + code[1] + code[2] + code[2] + code[3] + code[4]
    } else {
      return ""
    }
  }

export function gig26(code) {
    if (code.length == 6) {
      return code[1] + code[2] + code[3] + code[3] + code[4] + code[5]
    } else {
      return ""
    }
  }

export function gig36(code) {
    if (code.length == 6) {
      return code[2] + code[3] + code[4] + code[3] + code[4] + code[5]
    } else {
      return ""
    }
  }
//   ======= above Gua result function group =======


//  *******  Qi Gua function group  **********
export function number2code (numStr) {
  // numStr is a 6-char long string consists of [6, 7, 8, 9]
  // 6, 8 --> 0
  // 7, 9 --> 1

  let codeStr = ""
  for (let i=0; i<numStr.length; i++) {
      if (numStr[i] % 2 == 0) {
          codeStr = codeStr + '0'
      } else {
          codeStr = codeStr + '1'
      }
  }
  return codeStr
}


export function findGua(codeStr, lang) {

    if (codeStr.length == 6) {
      if (lang == "CN") {
        return zhouyicn[codeStr].fullName
      } else {
        return zhouyitw[codeStr].fullName
      }
        
    } else {
        return ""
    }
}

// export function autoQi() {
//     start = 50
//     return "678976"
// }

/*
function: stickReduction
This function is key to create yao number by 
大衍之數五十，其用四十有九，分而為二以象兩，掛一以象三，揲之以四以象四時，歸奇於扐以象閏，五歲再閏，故再扐而後掛。

Do 3 times and get the number of the remaining 4's bundles
Input: initArray: length 49, shuffled.

Algorithm:
- imitate the Da Yan method. I am not going to pick a split point across the whole array.
  I am going to randomly pick a split point from the middle section.
- The middle section for each iteration is about the same, the middle 24. 
- Push (bundleCount) into Yao array: the number [6|7|8|9] of the remaining 4's bundles (for a Yao)
- Return numStr (6 yao string)
*/
export function stickReduction(mergedSeed) {
    var stepMiddleRange = {
        49: [11, 40],  // 40 - 11 = 29
        44: [10,35],   // 35 - 10 = 25
        40: [9,32],    // 32 - 9  = 23
        36: [8,29],    // 29 - 8  = 21
        32: [7,26],    // 26 - 7  = 19
        28: [6,23]     // 23 - 6  = 17
    }

    var initArray = 0;
    var initArrayLength = 0;
    var timestamp;
    var timestamp_int;
    var timestamp_date_str;
    var yaoCount = 0;
    var splitCount = 0;
    var currentArray = [];
    var currentArrayLength = 0
    var currentMiddleRange = []
    var newMergedSeed = ""
    var kickIndex = 0
    var leftArray = []
    var rightArray = []
    var newLeftArray = [];
    var newRightArray = [];
    var newMergedArray = [];
    var tmpArray = [];
    var leftArrayLength = 0;
    var leftRemainder = 0;
    var rightArrayLength = 0;
    var rightRemainder = 0;
    var kickLeft = 0;
    var kickRight = 0;
    var bundleCount = 0;
    var numStr = "";
    
    //alert("initArray is " + initArray.toString())
    //alert("Starting Yao: initArray length is " + initArray.length)
    tmpArray = shuffleArray(daYanArray);
    tmpArray.pop(); // 掛一 get rid of the last one
    initArray = [].concat(tmpArray);
    initArrayLength = initArray.length;

    for (yaoCount = 1; yaoCount <= 6; yaoCount++ ) {
        // Initialize bundleCount = 0 for each new yao and the currentArray to be 49
        bundleCount = 0;
        currentArray = [].concat(initArray);
        currentArrayLength = initArrayLength;
        // splite 3 times for each yao and add boundleCount to numStr
        for (splitCount = 1; splitCount <= 3; splitCount++ ) {

            //alert(splitCount + " : currentArray length is : " + currentArrayLength )
            if (currentArrayLength == 49) currentMiddleRange = stepMiddleRange[49]
            else if (currentArrayLength == 44)  currentMiddleRange = stepMiddleRange[44]
            else if (currentArrayLength == 40) currentMiddleRange = stepMiddleRange[40]
            else if (currentArrayLength == 36)  currentMiddleRange = stepMiddleRange[36]
            else if (currentArrayLength == 32)  currentMiddleRange = stepMiddleRange[32]
            else currentMiddleRange = stepMiddleRange[28]
            
            // Get new timestamp
            timestamp = Date.now();
            timestamp_int = parseInt(timestamp);
            timestamp_date_str = new Date(timestamp_int);
            //kickIndex = getRndInteger(currentMiddleRange[0], currentMiddleRange[1]);
            newMergedSeed = timestamp_date_str + mergedSeed + yaoCount + splitCount;
            kickIndex = getHashKick(timestamp_int, currentArrayLength, newMergedSeed);
            //alert(splitCount + " : kickIndex is " + kickIndex);
            // By spliting into two arrays, kick out the kickIndex at the same time
            leftArray = currentArray.slice(0, kickIndex);
            rightArray = currentArray.slice(kickIndex + 1);

            // process left and right array seperately
            // LEFT:
            leftArrayLength = leftArray.length;
            leftRemainder = leftArrayLength % 4;
            tmpArray = shuffleArray(leftArray);
            //alert("## 1 ## tmpArray:" + tmpArray.toString());
            // kick things out
            if (leftRemainder != 0) kickLeft = leftRemainder;
            else kickLeft = 4;
            for (var i = 0; i < kickLeft; i++) tmpArray.pop();

            // newLeftArray is now shorter by kickNum (4, 3, 2 or 1 sticks)
            newLeftArray = [].concat(tmpArray);

            // alert("## 1 ## newLeftArray: " + newLeftArray.toString());

            // RIGHT:
            rightArrayLength = rightArray.length;
            rightRemainder = rightArrayLength % 4;
            tmpArray = shuffleArray(rightArray);
            //alert("## 1 ## tmpArray:" + tmpArray.toString());
            // kick things out
            if (rightRemainder != 0) kickRight = rightRemainder;
            else kickRight = 4;
            for (var i = 0; i < kickRight; i++) tmpArray.pop();

            // newRightArray is now shorter by kickNum (4, 3, 2 or 1 sticks)
            newRightArray = [].concat(tmpArray);

            //alert(splitCount + ": Total kickNum: " + (kickLeft + kickRight + 1));
            // alert("## 1 ## newRightArray: " + newRightArray.toString());

            newMergedArray = newLeftArray.concat(newRightArray);
            //alert("newMergedArray Length:" + newMergedArray.length);
            //alert("newMergedArray : " + newMergedArray);

            // 3, the remaining last 2 sub-arrays should be bundles of 4's. See how many bundles.
            bundleCount = newMergedArray.length / 4;
            //alert(splitCount + " : bundleCount is : " + bundleCount);

            // Now, need to rebuild the currentArray for the next round
            currentArray = [].concat(newMergedArray);
            currentArrayLength = currentArray.length;
        }
        numStr = numStr + bundleCount;
        //alert("numStr : " + numStr);
    }
    //alert("自動起卦爻數 : " + numStr);
    return numStr;
}


//*****************************/
// Internal functions
//*****************************/
function shuffleArray(originalArray) {
    let array = [].concat(originalArray);
    let currentIndex = array.length, temporaryValue, randomIndex;

    // While there remain elements to shuffle...
    while (0 !== currentIndex) {

        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;

        // And swap it with the current element.
        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
    }

  return array;
}

export function hashMe(e) {
    for(var r=0,i=0;i<e.length;i++) {
        r = (r<<5)-r+e.charCodeAt(i);
        r&=r;
    }
    return r
};

// === Check 承乘應與 info ===
export function checkYaoName(i) {
  let yaoNameArray = ["上爻", "5爻", "4爻", "3爻", "2爻", "初爻"]

  return yaoNameArray[i]
}

export function checkYaoType(gua_code, i) {
  let yaoType = ""
  let trueIndex = 5 - i
  if (gua_code[trueIndex] == 0) {
    yaoType = "陰爻"
  } else {
    yaoType = "陽爻"
  }
  return yaoType
}

export function checkMiddle(gua_code, i) {
  // 二爻位為下卦之中位，五爻位為上卦之中位，因此，居於這兩個爻位則稱得中，此為吉。
  // 若陰爻居於二爻位，陽爻居於五爻位，即六二與九五，既當位又得中，稱為中正，此為大吉。

  let middleText = ""
  let trueIndex = 5 - i
  if (trueIndex == 1) {
    // 2nd yao Yin 0 is good
    if (gua_code[trueIndex] == 0) {
      middleText = "得中(+)、六二中正(+)"
    } else {
      middleText = "得中(+)、九二不中正(-)"
    }
  } else if (trueIndex == 4) {
    // 5th yao Yang 1 is good
    if (gua_code[trueIndex] == 1) {
      middleText = "得中(+)、九五中正(+)"
    } else {
      middleText = "得中(+)、六五不中正(-)"
    }
  }
  return middleText
}

export function checkDangWei(gua_code, i) {
  // 初爻、三爻、五爻為陽爻，二爻、四爻、六爻為陰爻。
  // 若陽爻居於陽位，或陰爻居於陰位，則稱當位，為吉；反之，若陽爻居於陰位，陰爻居於陽位，則稱不當位，為凶。

  let trueIndex = 5 - i
  let dangWeiText = ""
  if (trueIndex % 2 == 0) {
    if (gua_code[trueIndex] == 1) {
      dangWeiText = "當位(+)"
    } else {
      dangWeiText = "不當位(-)"
    }
  } else {
    if (gua_code[trueIndex] == 0) {
      dangWeiText = "當位(+)"
    } else {
      dangWeiText = "不當位(-)"
    }
  }
  return dangWeiText
}

export function checkCouple(gua_code, i) {
  // check (1, 4) (2, 5) (3, 6) relationships
  // 應，上下兩卦之間，初爻與四爻，二爻與五爻，三爻與上爻之間的呼應關係，稱為應。
  // 若應位的爻為一陰一陽，則稱「相應」，此為吉；若應位的爻同陰同陽，則稱「無應」，此為凶。

  let trueIndex = 5 - i
  let coupleText = ""

  if (
    gua_code[trueIndex] !=
    (trueIndex < 3 ? gua_code[trueIndex + 3] : gua_code[trueIndex - 3])
  ) {
    coupleText = "相應(+)"
  } else {
    coupleText = "不相應(-)"
  }

  if (trueIndex == 0 || trueIndex == 3) {
    coupleText = "14" + coupleText
  } else if (trueIndex == 1 || trueIndex == 4) {
    coupleText = "25" + coupleText
  } else {
    coupleText = "36" + coupleText
  }
  return coupleText
}

export  function checkBi(gua_code, i) {
  // check 比，是比鄰之意
  // 若相鄰兩爻一陰一陽，則相比為「友」，此為吉；若相鄰兩爻同陰同陽，則相比為「敵」，此為凶。

  let trueIndex = 5 - i
  let biUpText = ""
  let biDownText = ""
  let biText = ""

  if (trueIndex == 0) {
    if (gua_code[trueIndex] != gua_code[trueIndex + 1]) {
      biUpText = "12相比為友(+)"
    } else {
      biUpText = "12相比為敵(-)"
    }
  } else if (trueIndex == 1) {
    if (gua_code[trueIndex] != gua_code[trueIndex - 1]) {
      biDownText = "21相比為友(+)"
    } else {
      biDownText = "21相比為敵(-)"
    }
    if (gua_code[trueIndex] != gua_code[trueIndex + 1]) {
      biUpText = "23相比為友(+)"
    } else {
      biUpText = "23相比為敵(-)"
    }
  } else if (trueIndex == 2) {
    if (gua_code[trueIndex] != gua_code[trueIndex - 1]) {
      biDownText = "32相比為友(+)"
    } else {
      biDownText = "32相比為敵(-)"
    }
    if (gua_code[trueIndex] != gua_code[trueIndex + 1]) {
      biUpText = "34相比為友(+)"
    } else {
      biUpText = "34相比為敵(-)"
    }
  } else if (trueIndex == 3) {
    if (gua_code[trueIndex] != gua_code[trueIndex - 1]) {
      biDownText = "43相比為友(+)"
    } else {
      biDownText = "43相比為敵(-)"
    }
    if (gua_code[trueIndex] != gua_code[trueIndex + 1]) {
      biUpText = "45相比為友(+)"
    } else {
      biUpText = "45相比為敵(-)"
    }
  } else if (trueIndex == 4) {
    if (gua_code[trueIndex] != gua_code[trueIndex - 1]) {
      biDownText = "54相比為友(+)"
    } else {
      biDownText = "54相比為敵(-)"
    }
    if (gua_code[trueIndex] != gua_code[trueIndex + 1]) {
      biUpText = "56相比為友(+)"
    } else {
      biUpText = "56相比為敵(-)"
    }
  } else if (trueIndex == 5) {
    if (gua_code[trueIndex] != gua_code[trueIndex - 1]) {
      biDownText = "65相比為友(+)"
    } else {
      biDownText = "65相比為敵(-)"
    }
  }
  biText = biUpText + " " + biDownText
  return biText
}

export function checkCC(gua_code, i) {
  // check 比，是比鄰之意
  // 若相鄰兩爻一陰一陽，則相比為「友」，此為吉；若相鄰兩爻同陰同陽，則相比為「敵」，此為凶。

  let trueIndex = 5 - i
  let ccUpText = ""
  let ccDownText = ""
  let ccText = ""
  let ride = "乘"
  let hold = "承"

  ccUpText = ""
  ccDownText = ""
  ccText = ""
  if (trueIndex == 0) {
    // 1st yao == 0
    if (gua_code[trueIndex] == 0) {
      gua_code[trueIndex + 1] == 0
        ? (ccUpText = "12陰承陰")
        : (ccUpText = "12陰承陽(+)")
    } else {
      // 1st yao == 1
      gua_code[trueIndex + 1] == 0
        ? (ccUpText = "12陽承陰(-)")
        : (ccUpText = "12陽承陽")
    }
  } else if (trueIndex == 5) {
    // 6th yao == 0
    if (gua_code[trueIndex] == 0) {
      gua_code[trueIndex - 1] == 0
        ? (ccDownText = "65陰乘陰")
        : (ccDownText = "65陰乘陽(-)")
    } else {
      // 6th yao == 1
      gua_code[trueIndex - 1] == 0
        ? (ccDownText = "65陽乘陰(+)")
        : (ccDownText = "65陽乘陽")
    }
  } else {
    if (gua_code[trueIndex] == 0) {
      gua_code[trueIndex + 1] == 0
        ? (ccUpText =
            (trueIndex + 1).toString() +
            (trueIndex + 2).toString() +
            "陰承陰")
        : (ccUpText =
            (trueIndex + 1).toString() +
            (trueIndex + 2).toString() +
            "陰承陽(+)")
      gua_code[trueIndex - 1] == 0
        ? (ccDownText =
            (trueIndex + 1).toString() + trueIndex.toString() + "陰乘陰")
        : (ccDownText =
            (trueIndex + 1).toString() + trueIndex.toString() + "陰乘陽(-)")
    } else {
      // yao 2 ~ 5
      gua_code[trueIndex + 1] == 0
        ? (ccUpText =
            (trueIndex + 1).toString() +
            (trueIndex + 2).toString() +
            "陽承陰(-)")
        : (ccUpText =
            (trueIndex + 1).toString() +
            (trueIndex + 2).toString() +
            "陽承陽")
      gua_code[trueIndex - 1] == 0
        ? (ccDownText =
            (trueIndex + 1).toString() + trueIndex.toString() + "陽乘陰(+)")
        : (ccDownText =
            (trueIndex + 1).toString() + trueIndex.toString() + "陽乘陽")
    }
  }

  ccText = ccUpText + "; " + ccDownText
  return ccText
}
// === End check 承乘應與 info ===

export function onlyUnique(value, index, self) {
  return self.indexOf(value) === index;
}


// This is a basic RNG from a range for testing only
// returns a random number between min (included) and max (excluded):
function getRndInteger(min, max) {
    return Math.floor(Math.random() * (max - min) ) + min;
  }

// This is the key range RNG with merged seeds
function rngWithSeedRange (min, max, mergedSeed) {
   
}

// ***** Tuning Auto Qi algorithm
// v001 - 9 a bit too many, about 10% more than the expected value.
// let startIndexArray = [11, 10, 9, 8, 7, 6]
// let rangeArray = [29, 25, 23, 21, 19, 17]

// v002 - seems to be a total failure, only 7 and 8. 2x 7's than expected. No 6 and 9 at all.
// let startIndexArray = [10, 9, 8, 7, 6, 5]
// let rangeArray = [30, 26, 24, 22, 20, 18]

// v003 - better than v001
// let startIndexArray = [9, 8, 7, 6, 5, 4]
// let rangeArray = [31, 27, 25, 23, 21, 19]

// v004 - so far the best, gua all within range (black). similar to v002: 6 is a bit less (around 10%)
// 7, 8 within 1%, 9 within 3%
// let startIndexArray = [9, 8, 7, 6, 5, 5]
// let rangeArray = [31, 27, 25, 23, 21, 18]

// v005 - the best of all!! all yaos within 3.05%
// All gua are black within 7.45%
let startIndexArray = [8, 8, 7, 6, 5, 5]
let rangeArray = [31, 27, 25, 23, 21, 18]

const lengthStartIndex = {
    49: startIndexArray[0],  
    44: startIndexArray[1],   
    40: startIndexArray[2],    
    36: startIndexArray[3],    
    32: startIndexArray[4],    
    28: startIndexArray[5]     
}
const base_range = {
    49: rangeArray[0],
    44: rangeArray[1],
    40: rangeArray[2],
    36: rangeArray[3],
    32: rangeArray[4],
    28: rangeArray[5],
};

function getHashKick(qigua_timestamp_int, arrayLength, newMergedSeed) {
    var hash = Sha256.hash(newMergedSeed);
    var hash_int = parseInt("0x" + hash);
    var hash_quotien = hash_int / qigua_timestamp_int;
    var index = hash_quotien % base_range[arrayLength];
    var kickIndex =  index + lengthStartIndex[arrayLength];

    return kickIndex;
}



// step1 to step 3 array in and out to become the input of a Yao
// export function inArrayOutYao(qigua_timestamp_int, ina, mergedSeed, yao_cnt, split_cnt) {
//     // Get the seed and start to generate Gua
//     // let leftArrayLength = 0;
//     // let leftRemainder = 0;
//     // let rightArrayLength = 0;
//     // let rightRemainder = 0;
//     // let kickNum = 4;
//     // let newLeftArray = [];
//     // let newRightArray = [];
//     // let newMergedArray = [];
//     var yao = 0;

//     // 1, kick 1 out from the daYanArray: 大衍之數五十，其用四十有九
//     //    Method: shuffleArray(daYanArray), then pop the last one out to form a new shorter array
//     //            and shullfe again.
//     var tmpArray = shuffleArray(ina);
//     var initArray = [];
//     //var initArrayLength = 0;
//     //alert("Shuffled array is " + tmpArray.toString());
//     //tmpArray.pop(); // get rid of the last one
//     initArray = [].concat(tmpArray);
//     //alert("tmpArray is " + tmpArray.toString());
//     //alert("initArray is " + initArray.toString());

//     // 2, pick an index from the middle 24 items. 分而為二以象兩
//     //    This picked index will be kicked out later. 掛一以象三
//     //    Use this index to slice the array into 2 sub-arrays.
//     //    揲之以四以象四時，歸奇於扐以象閏，五歲再閏，故再扐而後掛。…四營而成易，十有八變而成卦…
//     //    Each sub-array will be suffled.
//     //    The length % 4 to kick out the remainders.
//     //    The remaining 2 sub-arrays will be contacted and shuffled again.
//     //    ***!!!! ==> Do #2 three times.
//     //initArrayLength = initArray.length;
//     //alert("initArray length : " + initArrayLength);

//     // **************************************************
//     // Now do 3 times of stick reduction. return the number of remaining 4's bundles
//     // **************************************************
//     yao = stickReduction(qigua_timestamp_int, initArray, mergedSeed, yao_cnt, split_cnt)

//     return yao

//     /*
//     //let step1MiddleRange = [13, 38]; // middle 25 items for step1
//     let kickIndex = getRndInteger(13, 38);  // step1MiddleRange (13, 38)
//     //alert("kickIndex is " + kickIndex);
//     let leftArray = step1Array.slice(0, kickIndex);
//     let rightArray = step1Array.slice(kickIndex + 1);
//     // alert("step1Array: " + step1Array.toString());
//     // alert("leftArray: " + leftArray.toString());
//     // alert("rightArray: " + rightArray.toString());

//     // process left and right array seperately
//     // LEFT:
//     leftArrayLength = leftArray.length;
//     leftRemainder = leftArrayLength % 4;
//     tmpArray = shuffleArray(leftArray);
//     //alert("## 1 ## tmpArray:" + tmpArray.toString());
//     // kick things out
//     kickNum = 4;
//     if (leftRemainder != 4) kickNum = leftRemainder;
//     for (let i = 0; i < leftRemainder; i++) tmpArray.pop();
//     newLeftArray = tmpArray;

//     // alert("## 1 ## kickNum:" + kickNum);
//     // alert("## 1 ## newLeftArray: " + newLeftArray.toString());

//     // RIGHT:
//     rightArrayLength = rightArray.length;
//     rightRemainder = rightArrayLength % 4;
//     tmpArray = shuffleArray(rightArray);
//     //alert("## 1 ## tmpArray:" + tmpArray.toString());
//     // kick things out
//     kickNum = 4;
//     if (rightRemainder != 4) kickNum = rightRemainder;
//     for (let i = 0; i < rightRemainder; i++) tmpArray.pop();
//     newRightArray = tmpArray;

//     // alert("## 1 ## kickNum:" + kickNum);
//     // alert("## 1 ## newRightArray: " + newRightArray.toString());

//     newMergedArray = newLeftArray.concat(newRightArray);
//     alert("newMergedArray Length:" + newMergedArray.length);
//     // alert("newMergedArray : " + newMergedArray);

//     // 3, the remaining last 2 sub-arrays should be bundles of 4's. See how many bundles.
//     */
    
// }